import { render } from "./ProductOnPopout.vue?vue&type=template&id=480024fc&scoped=true"
import script from "./ProductOnPopout.vue?vue&type=script&lang=js"
export * from "./ProductOnPopout.vue?vue&type=script&lang=js"

import "./ProductOnPopout.vue?vue&type=style&index=0&id=480024fc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480024fc"]])

export default __exports__